import MuiAccordion from '@mui/material/Accordion'
import { styled } from '@mui/material/styles'

const StyledAccordion = styled(MuiAccordion)(() => ({
  border: 0,
  '&:before': {
    display: 'none'
  }
}))

export default StyledAccordion
